import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { DialogComponent } from '@prekog/common-ui';
import { DoctorConsultingHour } from '../updatedoctor/doctorconsultinghour';
import { AddConsultingHourDialogResult } from './addconsultinghourdialogresult';

@Component({
    selector: 'app-addconsultinghourdialog.ts',
    templateUrl: './addconsultinghourdialog.ts.component.html',
    styleUrls: ['./addconsultinghourdialog.ts.component.scss'],
    standalone: true,
    imports: [MatIconModule, ReactiveFormsModule, RouterModule, MatDialogModule, CommonModule, FormsModule]
})
export class AddconsultinghourDialogComponent extends DialogComponent {
    addConsultingHour = true;
    consultationForm?: FormGroup;
    doctorConsultingHour: DoctorConsultingHour = {};
    endTime: string | null = null;
    @ViewChild('endTimeInput') endTimeInput!: ElementRef;

    startTime: string | null = null;
    @ViewChild('startTimeInput') startTimeInput!: ElementRef;

    constructor(private _fb: FormBuilder) {
        super();
        this.createConsultationHourForm();
    }

    createConsultationHourForm() {
        this.consultationForm = this._fb.group({
            day: ['', [Validators.required]]
        });
    }

    collectConsultationHourData() {
        this.doctorConsultingHour = {
            day: this.consultationForm?.controls['day'].value as string | undefined,
            startTime: this.startTime!,
            endTime: this.endTime!
        };
    }

    addConsultation() {
        this.collectConsultationHourData();
        const addConsultingHourDialogResult: AddConsultingHourDialogResult = {
            doctorConsultingHour: this.doctorConsultingHour
        }
        this.accept(addConsultingHourDialogResult);
    }

    closeDialog() {
        this.reject();
    }

    onChangestartTime() {
        this.startTime = this.startTimeInput.nativeElement.value;
    }

    onChangeEndTime() {
        this.endTime = this.endTimeInput.nativeElement.value;
    }

    changeConsulting() {
        this.addConsultingHour = !this.addConsultingHour;
        this.startTime = null;
        this.endTime = null;
    }
}
